// 防抖：指触发事件后在 n 秒内函数只能执行一次，如果在 n 秒内又触发了事件，则会重新计算函数执行时间
// 用于：按钮click提交类，多次点击只执行一次，在delay毫秒内可能不执行，只会在停止后delay毫秒后 才执行
const debounce=function(fn, delay){
	let timer = null
	return function(){
		let content = this;
		let args = arguments;
		if(timer){
			clearTimeout(timer)
		}
		timer = setTimeout(()=>{
			fn.apply(content,args)
		}, delay)
	}
}
 
export default debounce


// import debounce from "@/common/debounce"
// methods:{
//     changeSeletc:debounce(function() {
//       console.log('防抖：',this.serves)
//     },500),
// }


// WEBPACK FOOTER //
// ./src/utils/debounce.js